module.exports = "<div class=\"chain-icon\" *ngIf=\"icon\">\n\t<app-icon [icon]=\"icon\"></app-icon>\n</div>\n"